import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-image",
  "use": "google-image-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-image\"><g clip-path=\"url(#google-image_clip0_2_61)\"><rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#D94641\" /><path d=\"M5 9.5l-3 4h12L10.5 8 7 12 5 9.5z\" fill=\"#fff\" /></g><defs><clipPath id=\"google-image_clip0_2_61\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol